import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Hero corner slide-in animation on page load
gsap.from('.hero-1-5__corner--top', {
    x: '-50%',
    opacity: 0,
    duration: 1.5,
    ease: 'power3.out',
});

gsap.from('.hero-1-5__corner--bottom', {
    x: '50%',
    opacity: 0,
    duration: 1.5,
    ease: 'power3.out',
});

gsap.from('.hero-1-5__text', {
    opacity: 0,
    duration: 1,
    ease: 'power3.out',
    opacity: 0,
});

gsap.to('.hero-1-5__text', {
    scrollTrigger: {
        trigger: '.hero-1-5',
        start: 'top top', // Start at the top of the viewport
        end: 'bottom top', // End when the bottom of the element reaches the top of the viewport
        scrub: 1,
    },
    y: '-30%', // Ending position (adjust for desired parallax effect)
});

// feature-3-1
gsap.fromTo('.feature-3-1__heading', 
    { y: '150%' }, // Starting position
    {
        scrollTrigger: {
            trigger: '.services-1-0',
            start: 'top center',
            end: 'bottom center',
            scrub: 1,
        },
        y: '-3%', // Ending position (adjust for desired parallax effect)
    }
);

gsap.fromTo('.feature-3-1__corner--top', 
    { y: '-20%' },
    {
        scrollTrigger: {
            trigger: '.feature-3-1',
            start: 'top center',
            end: 'bottom center',
            scrub: 1,
        },
        y: '5%', // Adjust the value for the desired parallax effect
    }
);

gsap.fromTo('.feature-3-1__corner--bottom', 
    { y: '40%' }, // Starting position
    {
        scrollTrigger: {
            trigger: '.feature-3-1',
            start: 'top center',
            end: 'bottom center',
            scrub: 1,
        },
        y: '0%', // Ending position
    }
);

// feature-3-2-a 
gsap.to('.feature-3-2-a__image-desktop', {
    scrollTrigger: {
        trigger: '.feature-3-2-a',
        start: 'top center',
        end: 'bottom center',
        scrub: 1,
    },
    y: '-10%', // Adjust the value for the desired parallax effect
});

gsap.to('.feature-3-2-a__image-mobile', {
    scrollTrigger: {
        trigger: '.feature-3-2-a',
        start: 'top center',
        end: 'bottom center',
        scrub: 1,
    },
    y: '-10%', // Adjust the value for the desired parallax effect
});

// feature-3-2-b
gsap.to('.feature-3-2-b__image-desktop', {
    scrollTrigger: {
        trigger: '.feature-3-2-b',
        start: 'top center',
        end: 'bottom center',
        scrub: 1,
    },
    y: '-5%', // Adjust the value for the desired parallax effect
});

gsap.to('.feature-3-2-b__image-mobile', {
    scrollTrigger: {
        trigger: '.feature-3-2-b',
        start: 'top center',
        end: 'bottom center',
        scrub: 1,
    },
    y: '-5%', // Adjust the value for the desired parallax effect
});

// Function to animate children of a given selector
function animateOnScroll(selector, triggerSelector = null) {
    gsap.utils.toArray(`${selector}`).forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: triggerSelector || element,
                start: "top bottom-=100",
                end: "bottom center",
                once: true,
            },
            opacity: 0,
            y: 50,
            duration: 0.8,
            ease: "power3.out",
            delay: index * 0.2 // Stagger effect
        });
    });
}

// List of classes to apply the animation to
const classesToAnimate = [
    { selector: '.feature-3-3__text > *', trigger: '.feature-3-3__text' },
    { selector: '.services-1-0__container > * > *', trigger: '.services-1-0__container' },
    { selector: '.feature-3-1__text > *', trigger: '.feature-3-1__text' },
    { selector: '.feature-3-2-a__card', trigger: null },
    { selector: '.feature-3-2-a__card > *', trigger: '.feature-3-2-a__card' },
    { selector: '.feature-3-2-b__card', trigger: null },
    { selector: '.feature-3-2-b__card > *', trigger: '.feature-3-2-b__card' },
    { selector: '.clients-2-0__container > * > *', trigger: '.clients-2-0__container' },
    { selector: '.form-1-0__container > * > *', trigger: '.form-1-0__container' },
];

// Apply the animation to each class in the list
classesToAnimate.forEach(({ selector, trigger }) => {
    animateOnScroll(selector, trigger);
});
